import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { ViewButton } from "../../components/mui/Buttons/Buttons";
import GlobalDialog from "../../components/mui/Dialogue/GlobalDialog";
import { getEditLogs } from "../../redux/features/generalSlice";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Stack,
  Typography,
} from "@mui/material";

const FinanceLogView = ({ requestID }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading, editLogs } = useSelector((state) => state.general);

  useEffect(() => {
    if (open) {
      dispatch(getEditLogs(requestID));
    }
  }, [open]);

  return (
    <GlobalDialog
      title={"Edit Logs"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"md"}
      closeButton={true}
      popupButton={
        <ViewButton size="medium" action={() => setOpen(true)}>
          View Logs
        </ViewButton>
      }
      content={
        <>
          <Box p={2}>
            <Stack spacing={2} direction="column">
              {editLogs?.map((log) => (
                <Card key={log.lead_edit_logs_id} variant="outlined">
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Edit Log ID: {log.lead_edit_logs_id}
                    </Typography>

                    <Typography variant="subtitle2" color="text.secondary">
                      Changed By: {log.changedBy}
                    </Typography>

                    <Typography variant="subtitle2" color="text.secondary">
                      Timestamp: {log.lead_edit_logs_created_timestamp}
                    </Typography>

                    <Divider sx={{ my: 1 }} />

                    {/* Added Items */}
                    {log.changeMessage.added.length > 0 && (
                      <>
                        <Typography variant="subtitle1" color="green">
                          Added:
                        </Typography>
                        {log.changeMessage.added.map((item, index) => (
                          <Typography key={index} variant="body2">
                            • {item}
                          </Typography>
                        ))}
                      </>
                    )}

                    {/* Modified Items */}
                    {log.changeMessage.modified.length > 0 && (
                      <>
                        <Typography variant="subtitle1" color="orange">
                          Modified:
                        </Typography>
                        {log.changeMessage.modified.map((item, index) => (
                          <Typography key={index} variant="body2">
                            • {item}
                          </Typography>
                        ))}
                      </>
                    )}

                    {/* Removed Items */}
                    {log.changeMessage.removed.length > 0 && (
                      <>
                        <Typography variant="subtitle1" color="red">
                          Removed:
                        </Typography>
                        {log.changeMessage.removed.map((item, index) => (
                          <Typography key={index} variant="body2">
                            • {item}
                          </Typography>
                        ))}
                      </>
                    )}

                    {/* If no changes */}
                    {log.changeMessage.added.length === 0 &&
                      log.changeMessage.modified.length === 0 &&
                      log.changeMessage.removed.length === 0 && (
                        <Typography variant="body2" color="text.secondary">
                          No changes recorded.
                        </Typography>
                      )}
                  </CardContent>
                </Card>
              ))}
            </Stack>
          </Box>
        </>
      }
    />
  );
};

export default FinanceLogView;
